import { cn } from 'utils/style'
import { Tab as TabType } from './types'

type TabProps = {
	tab: TabType
	isActive: boolean
	handleClick: (data: any) => void
}

const Tab = ({ tab, isActive, handleClick }: TabProps) => {
	return (
		<button
			type="button"
			className={cn(
				'bg-white p-2.5 text-xs font-semibold text-grayChateau sm:text-sm',
				isActive ? 'border-b-2 border-b-royalBlue bg-athensGray2 text-royalBlue' : ''
			)}
			onClick={handleClick}>
			{tab.label}
		</button>
	)
}

export default Tab
